import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { storeReferralCode } from "../../utils/referralTracking";

const ReferralCapture = () => {
  const { referralCode } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Checking referral link...");

  useEffect(() => {
    const captureReferral = async () => {
      const applied = await storeReferralCode(referralCode);
      setMessage(applied ? "Referral link applied" : "Referral link could not be applied");
      setTimeout(() => navigate("/signup", { replace: true }), 900);
    };

    captureReferral();
  }, [navigate, referralCode]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4">
      <div className="rounded-lg border border-slate-200 px-6 py-5 text-center shadow-sm">
        <p className="font-inter text-sm font-semibold text-primary">
          {message}
        </p>
      </div>
    </div>
  );
};

export default ReferralCapture;
